import { useState } from "react";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { selectUser } from "../store/userSlice";

function AddUser({ onAdd = () => null }) {
  const user = useSelector(selectUser);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const addUser = async (e) => {
    e.preventDefault();
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      Email: username,
      Password: password,
      ConfirmPassword: confirmPassword,
    });

    let response = await fetch("/auth/users", {
      method: "POST",
      body: bodyContent,
      headers: headersList,
    });

    let data = await response.json();
    if (response.ok) {
      toast.success(data.message);
      onAdd();
      setShow(false);
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };
  return (
    <>
      <Button variant="secondary" className="btn-sm" onClick={handleShow}>
        Add User
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Form onSubmit={addUser} className="border border-2 p-4 rounded-2">
            <Form.Group className="mb-3 row" controlId="username">
              <div className="col-3">
                <Form.Label>Email</Form.Label>
              </div>
              <div className="col-9">
                <Form.Control
                  type="email"
                  placeholder="Please enter your username "
                  value={username}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3 row" controlId="formPassword">
              <div className="col-3">
                <Form.Label>Password</Form.Label>
              </div>
              <div className="col-9">
                <Form.Control
                  type="password"
                  placeholder=" Please enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 row" controlId="confirm-password">
              <div className="col-3">
                <Form.Label>Confirm Password</Form.Label>
              </div>
              <div className="col-9">
                <Form.Control
                  type="password"
                  placeholder=" Please confirm your password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="btn-sm" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="secondary" className="btn-sm" onClick={addUser}>
            Add User
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddUser;
